<template>
  <div id="app" class="noto-naskh-arabic">
    <!-- <LandingPage v-if="showLandingPage" @ShowImageCard="showImageCard" /> -->
    <transition name="fade">
      <div v-if="showLandingPage" class="landing-page">
        <!-- Main Content -->
        <div  class="logo-container">
          <img src="./assets/LOGO PARDIS-min.jpg" alt="Logo" class="logo">
        </div>

        <div class="main-content">
          <div class="section">
            <a @click="ShowProjects" to="/image-card" class="link">پروژه ها</a>
          </div>
          <div class="section">
            <a @click="ShowAbout" to="/image-card" class="link">درباره ما</a>
          </div>
          <div class="section">
            <a @click="ShowCataloge" to="/image-card" class="link">کاتالوگ</a>
          </div>
          <div class="section">
            <a @click="ShowContact" to="/image-card" class="link">ارتباط با ما</a>
          </div>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div v-if="showProjects">
        <!-- <NavBar /> -->
        <!-- <ImageCard v-for="(image, index) in images" :key="index" :image="image" /> -->
        <nav class="navbar">
          <img src="./assets/logoo.jpg" alt="Logo" class="Navlogo">
          <div class="hamburger-menu" @click="toggleMenu">
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
          </div>
          <ul class="nav-links">
            <li>
              <a @click="ShowHome">خانه</a>
            </li>
            <li @click="ShowUrban">
              <a>شهرسازی</a>
            </li>
            <li @click="ShowArchitecture">
              <a>معماری</a>
            </li>
            <li @click="ShowInterior">
              <a>معماری داخلی</a>
            </li>
          </ul>
        </nav>
        <div v-if="showInterior">
          <InteriorProjects v-for="(image, index) in Interiorimages" :key="index" :image="image" />
        </div>
        <div v-if="showArchitecture">
          <ArchitectureProjects v-for="(image, index) in Architectureimages" :key="index" :image="image" />
        </div>
        <div v-if="showUrban">
          <UrbanProjects v-for="(image, index) in Urbanimages" :key="index" :image="image" />
        </div>
        <PageFooter />
      </div>
    </transition>
    <transition name="fade">
      <div v-if="showAbout">
        <!-- <NavBar /> -->
        <!-- <ImageCard v-for="(image, index) in images" :key="index" :image="image" /> -->
        <nav class="navbar">
          <img src="./assets/logoo.jpg" alt="Logo" class="Navlogo">
          <div class="hamburger-menu" @click="toggleMenu">
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
          </div>
          <ul class="nav-links">
            <li>
              <a @click="ShowHome">خانه</a>
            </li>
            <li @click="ShowCompany">
              <a>معرفی شرکت</a>
            </li>
            <li @click="ShowPersonel">
              <a>اعضا</a>
            </li>
            <li @click="ShowCertificate">
              <a>گواهی ها</a>
            </li>
          </ul>
        </nav>

        <div v-if="showCertificate">
          <CertificateAbout v-for="(image, index) in Certificateimages" :key="index" :image="image" />
        </div>
        <div v-if="showCompany">
          <CompanyAbout v-for="(image, index) in Companyimages" :key="index" :image="image" />
        </div>
        <div v-if="showPersonel">
          <PersonelAbout v-for="(image, index) in Personalimages" :key="index" :image="image" />
        </div>
        <PageFooter />
      </div>
    </transition>
    <transition name="fade">
      <div v-if="showContact">
        <!-- <NavBar /> -->
        <!-- <ImageCard v-for="(image, index) in images" :key="index" :image="image" /> -->
        <nav class="navbar">
          <img src="./assets/logoo.jpg" alt="Logo" class="Navlogo">
          <div class="hamburger-menu" @click="toggleMenu">
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
          </div>
          <ul class="nav-links">
            <li>
              <a @click="ShowHome">خانه</a>
            </li>
          </ul>
        </nav>
        <div>
          <ContactUs />
        </div>
        <PageFooter />
      </div>
    </transition>
    <transition name="fade">
      <div v-if="showCataloge">
        <!-- <NavBar /> -->
        <!-- <ImageCard v-for="(image, index) in images" :key="index" :image="image" /> -->
        <nav class="navbar">
          <img src="./assets/logoo.jpg" alt="Logo" class="Navlogo">
          <div class="hamburger-menu" @click="toggleMenu">
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
          </div>
          <ul class="nav-links">
            <li>
              <a @click="ShowHome">خانه</a>
            </li>
          </ul>
        </nav>
        <div>
          <Cataloge />
        </div>
        <PageFooter />
      </div>
    </transition>
  </div>
</template>

<script>

import UrbanProjects from './components/Projects/UrbanProjects.vue';
import ArchitectureProjects from './components/Projects/ArchitectureProjects.vue';
import InteriorProjects from './components/Projects/InteriorProjects.vue';
import CompanyAbout from './components/About/CompanyAbout.vue';
import CertificateAbout from './components/About/CertificateAbout.vue';
import PersonelAbout from './components/About/PersonelAbout.vue';
import ContactUs from './components/Contact/ContactUs.vue';
import Cataloge from './components/Cataloge.vue';
import PageFooter from './components/PageFooter.vue';
import imageData from './data.js';
import PersonelData from './PersonelData.js';
import CompanyData from './CompanyData.js';
import CertificateData from './CertificateData.js';
import InteriorData from './InteriorData.js';
import ArchitectureData from './ArchitectureData.js';
import UrbanData from './UrbanData.js';

export default {
  name: 'App',
  components: {
    UrbanProjects,
    ArchitectureProjects,
    InteriorProjects,
    CompanyAbout,
    CertificateAbout,
    PersonelAbout,
    ContactUs,
    Cataloge,
    PageFooter
  },
  props: ['msg'],
  data() {
    return {
      isVisible: true,
      images: [],
      Personalimages: [],
      Companyimages: [],
      Certificateimages: [],
      Interiorimages: [],
      Architectureimages: [],
      Urbanimages: [],
      showLandingPage: true,
      showProjects: false,
      showArchitecture: true,
      showImageCard: false,
      showInterior:false,
      showAbout:false,
      showCompany:true,
      showPersonel:false,
      showCertificate:false,
      showContact:false,
      showCataloge:false,
      
    };
  },
  mounted() {
    this.loadImages();
    this.smoothScroll();
  },
  el: '.navbar',
  methods: {
    scrollToTop1() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    toggleMenu() {
      const navLinks = document.querySelector('.nav-links');
      navLinks.classList.toggle('active');
    },
    ShowImageCard() {
      this.showLandingPage = false;
      this.showImageCard = false;
    },
    ShowProjects() {
      this.fadeOutLandingPage(() => {
      this.scrollToTop1();
      this.showLandingPage = false;
      this.showProjects = true;
      this.showAbout = false;
      this.showArchitecture = true;
      this.showUrban = false;
      this.showInterior = false;
    });
    },
    ShowHome() {
      this.fadeOutLandingPage(() => {
      this.scrollToTop1();
      this.showLandingPage = true;
      this.showProjects = false;
      this.showArchitecture = false;
      this.showUrban = false;
      this.showInterior = false;
      this.showAbout = false;
      this.showCompany = true;
      this.showCertificate = false;
      this.showPersonel = false;
      this.showContact = false;
      this.showCataloge = false;
    });
    },
    ShowUrban() {
      this.scrollToTop1();
      const navLinks = document.querySelector('.nav-links');
      navLinks.classList.toggle('active');
      this.showUrban = true;
      this.showArchitecture = false;
      this.showInterior = false;

    },
    ShowArchitecture() {
      this.scrollToTop1();
      const navLinks = document.querySelector('.nav-links');
      navLinks.classList.toggle('active');
      this.showArchitecture = true;
      this.showUrban = false;
      this.showInterior = false;

    },
    ShowInterior() {
      this.scrollToTop1();
      const navLinks = document.querySelector('.nav-links');
      navLinks.classList.toggle('active');
      this.showInterior = true;
      this.showUrban = false;
      this.showArchitecture = false;
    },
    ShowAbout() {
      this.fadeOutLandingPage(() => {
      this.scrollToTop1();
      this.showProjects = false;
      this.showAbout = true;
      this.showLandingPage = false;
      this.showCompany = true;
      this.showCertificate = false;
      this.showPersonel = false;
      });
    },
    ShowCompany() {
      this.scrollToTop1();
      const navLinks = document.querySelector('.nav-links');
      navLinks.classList.toggle('active');
      this.showCompany = true;
      this.showCertificate = false;
      this.showPersonel = false;
    },
    ShowCertificate() {
      this.scrollToTop1();
      const navLinks = document.querySelector('.nav-links');
      navLinks.classList.toggle('active');
      this.showCompany = false;
      this.showCertificate = true;
      this.showPersonel = false;
    },
    ShowPersonel() {
      this.scrollToTop1();
      const navLinks = document.querySelector('.nav-links');
      navLinks.classList.toggle('active');
      this.showCompany = false;
      this.showCertificate = false;
      this.showPersonel = true;
    },
    ShowCataloge() {
      this.fadeOutLandingPage(() => {
      this.scrollToTop1();
      this.showProjects = false;
      this.showCataloge = true;
      this.showLandingPage = false;
      this.showCompany = true;
      this.showCertificate = false;
      this.showPersonel = false;
      });
    },
    ShowContact() {
      this.scrollToTop1();
      this.fadeOutLandingPage(() => {
      this.showLandingPage = false;
      this.showContact = true;
    },
    );
    },
    
    
    loadImages() {
      // Populate images array with data from imageData
      imageData.forEach(data => {
        this.images.push(data);
      });
      PersonelData.forEach(data => {
        this.Personalimages.push(data);
      });
      CompanyData.forEach(data => {
        this.Companyimages.push(data);
      });
      CertificateData.forEach(data => {
        this.Certificateimages.push(data);
      });
      InteriorData.forEach(data => {
        this.Interiorimages.push(data);
      });
      ArchitectureData.forEach(data => {
        this.Architectureimages.push(data);
      });
      UrbanData.forEach(data => {
        this.Urbanimages.push(data);
      });
    },
    smoothScroll() {
      const anchorLinks = document.querySelectorAll('a[href^="#"]');
      anchorLinks.forEach(link => {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          const targetId = this.getAttribute('href').slice(1);
          const targetElement = document.getElementById(targetId);
          if (targetElement) {
            targetElement.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
              duration: 1000
            });
          }
        });
      });
    },
    // ShowImageCard() {
    //   this.showLandingPage = false;
    //   this.showImageCard = true;
    // }
    fadeOutLandingPage(callback) {
      // Set a timeout to ensure the animation completes before changing visibility
      setTimeout(() => {
        callback();
      }, 500); // Adjust this value to match the duration of the fade-out animation
    }
  }
}
</script>

<style>
.noto-naskh-arabic {
  font-family: "Noto Naskh Arabic", serif;
  font-optical-sizing: auto;
  font-style: normal;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
.logo {
  position: absolute;
  top: 20px; /* Adjust top position as needed */
  right: -50%;
  transform: translateX(-55%);
  width: 55%; /* Set width to 10% of the viewport width */
  height: auto; /* Maintain aspect ratio */
}
.logo-container{
  position: absolute;
  top: 20px; /* Adjust top position as needed */
  left: 17.5%;
  width: 35%;
}


.section-container.fade-enter-active {
  animation: fadeIn 0.5s ease;
}
.main-content {
  display: flex;
  justify-content: center;
  align-items: center;
  /* Center vertically */
  height: 100vh;
  /* Set height to viewport height */
}

/* Apply the line style to all links except the first one */
.section:not(:first-child) .link:before {
  content: '';
  position: absolute;
  top: calc(50% - 20vh); /* Adjusted to 40% of screen height */
  left: -10px; /* Adjusted to create a gap between the line and the link */
  height: 40vh; /* Set to 40% of screen height */
  width: 1px;
  background-color: #999; /* Adjusted color for more defined shape */
  z-index: -1; /* Push the line behind the link text */
}

/* Adjust the position of the line for the second link */
.section:nth-child(2) .link:before {
  left: -20px; /* Move the line further to the left */
}

.section {
  text-align: center;
  margin: 10px;
  position: relative; /* Make sure the section is relative for absolute positioning of links */
}

.link {
  text-decoration: none;
  color: #000000;
  font-size: 24px;
  transition: all 0.3s ease;
  position: relative;
  padding-left: 30px; /* Increase left padding to create equal distance from the lines */
  padding-right: 30px; /* Increase right padding for symmetry */
}

.link:hover {
  color: #555;
  font-size: 28px;
  margin-top: -5px;
  cursor: pointer;
}


#app {
  overflow-y: auto;
}

html {
  scroll-behavior: smooth;
}

.navbar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #fff;
  /* Changed to white */
  color: #000;
  /* Changed to black */
  padding: 30px 0;
  z-index: 999;
}

.navbar ul {
  direction: rtl;
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
}

.navbar ul li {
  margin: 0 20px;
}

.navbar ul li a {
  text-decoration: none;
  color: #000;
  /* Changed to black */
  font-size: 18px;
  position: relative;
  cursor: pointer;

}

.navbar ul li a::after {
  content: '';
  position: absolute;
  width: 0%;
  height: 2px;
  background-color: #000;
  /* Changed to black */
  bottom: -3px;
  left: 0;
  transition: width 0.3s;
}

.navbar ul li a:hover::after {
  width: 100%;
}
.Navlogo {
  margin-right: auto; /* Push logo to the far left */
  margin-left: 20px; /* Add margin for spacing */
  width: 5.7%; /* Set width of the logo */
  height: auto; /* Maintain aspect ratio */
  position: absolute; /* Position the logo relative to its container */
  top: -10px; /* Move the logo slightly up */
}
.hamburger-menu {
  display: none;
  cursor: pointer;
  position: absolute;
  top: 20px;
  right: 20px;
}

.hamburger-menu .line {
  width: 25px;
  height: 3px;
  background-color: #000;
  margin: 5px 0;
}

/* Media query for smaller screens */
@media screen and (max-width: 768px) {
  .link {
    font-size: 15px; /* Decrease font size for smaller screens */
    padding-left: 1px; /* Decrease left padding for smaller screens */
    padding-right: 1px; /* Decrease right padding for smaller screens */
  }

  .link:before {
    top: calc(50% - 20vh); /* Adjusted to 20% of screen height */
    height: 20vh; /* Set to 20% of screen height */
    left: -5px; /* Adjusted to create a gap between the line and the link */
  }
  .section:nth-child(2) .link:before {
  left: -10px; /* Move the line further to the left */
}

  .navbar ul li {
  margin: 5px 10px;
  }
  .navbar ul {
    direction: rtl;
    display: none;
    flex-direction: column;
    position: absolute;
    top: 50px;
    right: 0;
    width: 100%;
    background-color: #fff;
    padding: 50px 10px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    z-index: 999;
  }
  .navbar ul.active {
    display: flex;
  }

  .hamburger-menu {
    display: block;
  }
  .logo {
  position: absolute;
  top: 20px; /* Adjust top position as needed */
  left: 50%;
  transform: translateX(-55%);
  width: 45%; /* Set width to 10% of the viewport width */
  height: auto; /* Maintain aspect ratio */
}
.Navlogo {
  margin-right: auto; /* Push logo to the far left */
  margin-left: 40%; /* Add margin for spacing */
  width: 13%; /* Set width of the logo */
  height: auto; /* Maintain aspect ratio */
  position: absolute; /* Position the logo relative to its container */
  top: 1px; /* Move the logo slightly up */
}
.logo {
  position: absolute;
  top: 20px; /* Adjust top position as needed */
  left: 70%;
  transform: translateX(-55%);
  width: 55%; /* Set width to 10% of the viewport width */
  height: auto; /* Maintain aspect ratio */
}
.logo-container{
  position: absolute;
  top: 20px; /* Adjust top position as needed */
  left: -18%;
  width: 100%;
}
}
</style>
